import { useRef, useState } from 'react';

export const useCarouselScrollLock = () => {
  const touchStart = useRef({ x: 0, y: 0 });
  const [isHorizontalScroll, setIsHorizontalScroll] = useState(false);
  const threshold = 10; // Minimum distance to determine swipe direction

  const handleTouchStart = (e: any) => {
    const touch = e.touches[0];
    touchStart.current = { x: touch.clientX, y: touch.clientY };
    setIsHorizontalScroll(false);
  };

  const handleTouchMove = (e: any) => {
    const touch = e.touches[0];
    const dx = touch.clientX - touchStart.current.x;
    const dy = touch.clientY - touchStart.current.y;

    // If user has not yet committed to a scroll direction
    if (
      !isHorizontalScroll &&
      Math.abs(dx) > Math.abs(dy) &&
      Math.abs(dx) > threshold
    ) {
      setIsHorizontalScroll(true);
    }

    // Lock vertical scroll only if horizontal swipe is detected
    if (isHorizontalScroll) {
      e.preventDefault(); // Prevent vertical scrolling
    }
  };

  return {
    handleTouchStart,
    handleTouchMove,
  };
};
